export enum DownloadImgType {
    jpg = 'jpg',
    png = 'png',
    ppt = 'ppt',
    pdf = 'pdf',
}
